import { Polygon } from "@usedapp/core";
import { Contract } from "ethers";

import PresaleABI from "../contracts/artifacts/contracts/PresaleUpgradeable.sol/PresaleUpgradeable.json";

export const TokenName = "Aarya";
export const TokenSymbol = "ARY";

export const useSupportedNetworks = {
  [Polygon.chainId]: {
    token: {
      contractAddress: "0x0c3B13f9D5156d1195644852661bA61ae53A423C",
      name: TokenName,
      symbol: TokenSymbol,
      decimals: 18,
    },
    native: {
      contractAddress: "0x0000000000000000000000000000000000001010",
      name: Polygon?.nativeCurrency?.name,
      symbol: Polygon?.nativeCurrency?.symbol,
      decimals: Polygon?.nativeCurrency?.decimals,
    },
    presaleAddress: "0xA2Ae3d93f5f428449BcD0db05aa12287900B839c",
    presaleContractInterface: new Contract(
      "0xA2Ae3d93f5f428449BcD0db05aa12287900B839c",
      PresaleABI?.abi
    ),
    explorerLink: {
      name: "https://polygonscan.com",
    },
    nativeFunctions: Polygon,
  },
};
